import {GET_COMPLETED_INVOICES} from "./ActionType";

export default function completedInvoices(state = {partial:[], completed:[]}, action) {
  const {type, payload} = action;

  switch (type) {
    case GET_COMPLETED_INVOICES:
      return (state = payload);
      
    default:
      return state;
  }
}
